import React, { useState } from 'react';
import styled from 'styled-components';
import { Title } from '../../UI/Typography';
import { Container } from '../../UI/Containers';
import ReportView from './ReportView';
import AnalyticsView from './AnalyticsView';

const PageContainer = styled(Container)`
  padding: ${({ theme }) => theme.spacing.lg};
  background-color: ${({ theme }) => theme.colors.background};
  max-width: 1200px;
  margin: 0 auto;
`;

const TitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.md};
`;

const ToggleContainer = styled.div`
  display: flex;
  gap: 8px;
`;

const ToggleButton = styled.button`
  background: ${({ $active, theme }) => ($active ? theme.colors.primary : theme.colors.surface)};
  color: ${({ $active, theme }) => ($active ? theme.colors.onPrimary : theme.colors.text)};
  border: 1px solid ${({ theme }) => theme.colors.border};
  padding: ${({ theme }) => `${theme.spacing.sm} ${theme.spacing.sm}`};
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
`;

function MonthlyReports() {
  const [tab, setTab] = useState('report');
  const title = tab === 'report' ? 'Monthly Reports' : 'Monthly Analytics';

  return (
    <PageContainer>
      <TitleRow>
        <Title>{title}</Title>
        <ToggleContainer>
          <ToggleButton $active={tab === 'report'} onClick={() => setTab('report')}>
            Report
          </ToggleButton>
          <ToggleButton $active={tab === 'analytics'} onClick={() => setTab('analytics')}>
            Analytics
          </ToggleButton>
        </ToggleContainer>
      </TitleRow>

      {tab === 'report' ? <ReportView /> : <AnalyticsView />}
    </PageContainer>
  );
}

export default MonthlyReports;
